import React from 'react';

const Contact = () => {
  return <div><h1>Contact Page (not done!!)</h1></div>;
};

export default Contact;